module.exports = __webpack_public_path__ + "media/images/flags/16/Malawi-7126586d3e1685c66be39f12c12b3b5b.png";